module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'utl3dxyk',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
